import React from "react"

import ReviewsSectionDesktop from "./ReviewsSectionDesktop"
import ReviewsSectionMobile from "./ReviewsSectionMobile"

const ReviewsSection = ({ section, practice, theme, highlightedField, viewMode = "", deviceType = "desktop" }) => {
  // If viewMode is explicitly set (from preview), use that to determine which component to show
  if (viewMode === "mobile") {
    return (
      <ReviewsSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  if (viewMode === "desktop") {
    return (
      <ReviewsSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  // Use server-side device detection for public pages
  if (deviceType === "mobile") {
    return (
      <ReviewsSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  // Default to desktop for desktop devices
  return (
    <ReviewsSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
  )
}

export default ReviewsSection
